import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
mutation revokeAdminRightFromUser (
    $id: ID!
) {
    revokeAdminRightFromUser (
        id: $id
    ) {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/revokeAdminRightFromUser.ts